import { FC } from 'react';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { ReferralSystemTab } from './constants';
import { PiggyBank } from './piggyBank/PiggyBank';

import css from './ReferralSystemPage.module.css';

import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { useTabs } from 'v2/hooks/useTabs';

export const ReferralSystemPage: FC = () => {
  const { activeTab, onTabChange } = useTabs<ReferralSystemTab>(ReferralSystemTab.PIGGY_BANK);

  return (
    <PageLayout className={css.referralSystemPage} overflow="hidden">
      <PageTitle>Referral System V2</PageTitle>

      <Tabs value={activeTab} onChange={(_, v) => onTabChange(v)}>
        <Tab value={ReferralSystemTab.PIGGY_BANK} label="Piggy Bank" />
      </Tabs>

      <div className={css.referralSystemPageContent}>{activeTab === ReferralSystemTab.PIGGY_BANK && <PiggyBank />}</div>
    </PageLayout>
  );
};
